/* eslint-disable */
/*
Everything passed the linter, except for errors on lines 340/341.  The following error 
occurs with the linter.  At the time of this commit, I could not find a solution on google
345:78  error  Insert `␍⏎··············`  prettier/prettier
347:78  error  Insert `␍⏎··············`  prettier/prettier
*/
import React, { FC, useState, useEffect, useContext, memo } from 'react';
import { useSelector } from 'react-redux';
import injectSheet from 'react-jss';
import { List } from 'Components/Lists';
import { modalShow } from 'Containers/Modal/actions';
import { useDispatch } from 'react-redux';
import { leadListGQL, duplicateListGQL } from './gqlQuery';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery, useMutation } from '@apollo/react-hooks';
import { FormattedDate } from 'Utils/formattedDate';
import { Loading } from 'Components/Loading';
import { Center } from 'Components/Helpers';
import { Paging } from 'Components/Paging';
import { SearchBar } from 'Components/SearchBar';
import { toastMessage } from 'Containers/Toast/actions';
import UserDetailsContext from 'Context/userDetailsContext';
import SmartList from 'Components/SmartList';
import More from 'Assets/ui/more.svg';
import styleSheet from './styles';
import { useHistory } from 'Utils/router';
import { loadFilterStateFromAttributes } from 'Containers/Filter/actions/filter.actions';
import { Button } from '../../components/Buttons';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { areEqual } from 'Utils/areEqual';
import withErrorBoundary from 'HOC/ErrorBoundary';

interface Props {
  instId: string;
  accountId: string;
  classes: any;
}

const DEFAULT_SORTING_COLUMN = 'lastModified';
const DEFAULT_SORTING_DIRECTION = 'desc';
const columns = ['name', 'attributes', 'createdBy', 'leads', 'lastModified'];
const allColumns = ['name', 'attributes', 'createdBy', 'leads', 'lastModified'];

const mapColumnsToKeys = (column: string, direction?: string) => {
  switch (column) {
    case 'name':
      return `name:${direction}`;
    case 'attributes':
      return `attributes:${direction}`;
    case 'createdBy':
      return `createUser:${direction}`;
    case 'leads':
      return `count:${direction}`;
    case 'lastModified':
      return `updatedAt:${direction}`;
    default:
      return '';
  }
};

const LeadsList: FC<Props> = memo((props: Props) => {
  const userDetails = useContext(UserDetailsContext);
  const Dispatch = useDispatch();
  const Selector = useSelector((selectors: any) => selectors);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const history = useHistory();
  const [searchError, setSearchError] = useState('');
  const {
    helpers: {
      metrics: { store: metricsStore },
    },
    actions: { track },
  } = useContext(ProductAnalyticsContext);

  const { instId, accountId, classes } = props;

  const [sortColumnObject, setSortColumnObject] = useState({
    column: DEFAULT_SORTING_COLUMN,
    direction: DEFAULT_SORTING_DIRECTION,
  });

  // graphQL responses //
  const { loading, data, refetch } = useQuery(leadListGQL, {
    notifyOnNetworkStatusChange: true,
    variables: {
      inst_id: instId,
      account_id: accountId,
      sort: mapColumnsToKeys(
        sortColumnObject.column,
        sortColumnObject.direction
      ),
      size: 10,
      page: page,
      search: searchTerm,
    },
    fetchPolicy: 'cache-and-network',
  });

  const [duplicateList, { loading: dupLoading, data: dupData }] = useMutation(
    duplicateListGQL,
    {
      onCompleted: listData => {
        Dispatch(
          toastMessage({
            message: `<i>${listData.listDuplicate.data.name}</i> has been created successfully`,
            position: 'bottom',
          })
        );
      },
    }
  );

  const modifiedList =
    data?.paginatedList?.list?.map((item: any) => {
      //This is done because the linter does not like assigning values to item.
      const newItem = { ...item };
      //Format Date
      newItem.lastModified = FormattedDate(item.lastModified);
      //Format Name (until back end sends proper name formatting)
      const createdBy = newItem.createdBy.split('.');
      if (createdBy.length > 1) {
        newItem.createdBy = `${createdBy[0]} ${createdBy[1].charAt(0)}`;
      }

      return newItem;
    }) || [];

  const leadList = { list: modifiedList };

  useEffect(() => {
    // Causes the query to refetch when component re-renders, this provides instantanious updates when you make changes to the list //
    refetch();
  }, [Selector.modal, dupData, searchTerm]);

  const onMenuChange = (event: any) => {
    // Combined Analytics event tracking
    track('list_actions', {
      list_name: event.target.listName,
      list_id: event.target.id,
      list_action: event.target.label,
      audience_count: event.target.count,
      list_type: event.target.listType,
      column_count: event.target.tableColumns.length,
    });

    switch (event.target.label.toLowerCase()) {
      case 'duplicate':
        if (dupLoading) return;
        duplicateList({
          variables: {
            inst_id: userDetails.instId,
            account_id: userDetails.accountId,
            name: `${event.target.listName} (copy)`,
            id: event.target.id,
          },
        });
        break;
      case 'delete':
        Dispatch(
          modalShow({
            title: 'Delete List',
            visible: true,
            width: 560,
            titlePosition: 'center',
            children: (
              <SmartList.Delete
                id={event.target.id}
                listName={event.target.listName}
              ></SmartList.Delete>
            ),
          })
        );
        break;
      case 'rename':
        Dispatch(
          modalShow({
            title: 'Rename Inquiry List',
            visible: true,
            width: 640,
            titlePosition: 'center',
            children: (
              <SmartList.Edit
                count={event.target.count}
                id={event.target.id}
              ></SmartList.Edit>
            ),
          })
        );
        break;
      case 'permissions':
        Dispatch(
          modalShow({
            title: 'List Permissions',
            visible: true,
            width: 560,
            titlePosition: 'center',
            children: (
              <SmartList.Permissions
                defaultValue={event.target.shared ? 'shared' : 'private'}
                id={event.target.id}
              ></SmartList.Permissions>
            ),
          })
        );
        break;
      case 'load attributes in explore':
        loadFilterStateFromAttributes(Dispatch, event.target.loadAttributes);

        //Redirect to the leads/explore page
        history.push('/inquiries/explore');
        break;
      default:
        break;
    }
  };
  const onSearch = (e: any) => {
    setPage(1);
    setSearchTerm(e.target.value.length >= 3 ? e.target.value : '');
    setSearchError(
      e.target.value.length > 0 &&
        e.target.value.length < 3 &&
        '[at least 3 characters required to search]'
    );
  };

  // Combined Analytics event
  useEffect(() => {
    // subscribe to the user Metrics store
    const { listTotalCount, listSharedCountExclusive }: any = metricsStore;

    if (
      data &&
      data.paginatedList &&
      listSharedCountExclusive &&
      listSharedCountExclusive
    ) {
      track('audiences_lists_page_viewed', {
        number_of_lists: data.paginatedList.list.length,
        shared_lists_count: listSharedCountExclusive,
        own_lists_count: listTotalCount,
      });
    }
  }, [data]);

  // Render based on graphQL resonses //
  if (data && data.paginatedList) {
    return (
      <>
        <div
          className={classes.header}
          style={{ opacity: loading ? 0.4 : 1, marginTop: '25px' }}
        >
          <h2>Inquiry Lists</h2>
          <SearchBar
            onChange={(event: any) => {
              setSearch(event.target.value);
              setSearchError('');
            }}
            disabled={data.paginatedList.totalListsForUser === 0}
            disableToolTip
            name={'Search Lists'}
            placeholder="Search by List Name or Created By"
            width={310}
            fields={['List Name', 'Created By']}
            searchable={
              (search.length >= 3 && searchTerm !== search && true) || false
            }
            onSearch={onSearch}
            toolTipWidth="215px"
            error={searchError}
          />
        </div>
        {data.paginatedList.totalListsForUser > 0 ? (
          <div style={{ opacity: loading || dupLoading ? 0.4 : 1 }}>
            <List
              audienceData={leadList}
              tableColumns={columns}
              allColumns={allColumns}
              boxShadow={
                leadList.list.length === 0
                  ? 'none'
                  : '0 2px 4px 0 rgba(0,0,0,0.15)'
              }
              menuConfig={{
                use: true,
                hover: true,
                indicator: More,
                indicatorStyles: {
                  top: '3px',
                  right: '10px',
                  position: 'relative',
                  opacity: 0,
                },
                onChange: onMenuChange,
              }}
              sort={{
                activeColumn: {
                  name: sortColumnObject.column,
                  direction: sortColumnObject.direction,
                },
                events: {
                  onClickSortHandler: (column: string) => {
                    let newSortingDirection;
                    if (column === sortColumnObject.column) {
                      newSortingDirection =
                        sortColumnObject.direction === 'desc' ? 'asc' : 'desc';
                    } else {
                      newSortingDirection = 'desc';
                    }
                    setSortColumnObject({
                      column: column,
                      direction: newSortingDirection,
                    });
                  },
                },
              }}
              caret={true}
            />
          </div>
        ) : (
          <div className={classes.noResultContainer}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              <div style={{ marginTop: '-80px' }}>
                <div className={classes.noListsText}>You have no Lists.</div>

                <Button
                  buttonType={'defaultBlue'}
                  onClick={() => {
                    history.push('/inquiries/explore');
                  }}
                ></Button>
              </div>
            </div>
          </div>
        )}
        {(loading || dupLoading) && (
          <Center>
            <Loading />
          </Center>
        )}
        {data.paginatedList.totalRecords > 0 && (
          <div style={{ transform: 'translateX(35px) translateY(-10px)' }}>
            <Paging
              recordsPerPage={10}
              page={data.paginatedList.page}
              totalRecords={data.paginatedList.totalRecords}
              prev={() =>
                setPage(page <= 1 ? data.paginatedList.totalPages : page - 1)
              }
              next={() =>
                setPage(page >= data.paginatedList.totalPages ? 1 : page + 1)
              }
              position="right"
              parent={'Leads List'}
              totalPages={data.paginatedList.totalPages}
            />
          </div>
        )}
      </>
    );
  } else {
    return (
      <Center>
        <Loading />
      </Center>
    );
  }
}, areEqual);

export default withErrorBoundary(injectSheet(styleSheet)(LeadsList));
